import { CarrierT } from "../../../../../domain";
import React from "react";

type CarrierInformationProps = {
  carrier: CarrierT;
};

export const CarrierInformation = ({
  carrier,
}: CarrierInformationProps): React.ReactElement => {
  return (
    <section className="grid gap-[10px]">
      <h1 className="text-[16px] font-[700]">Carrier</h1>
      <section className="grid grid-flow-col items-center justify-between gap-[20px]">
        <section className="grid ">
          <span className="text-[12px] font-[700] capitalize text-[#3C7CF3]">
            {carrier.name?.toLowerCase() ?? "- -"}
          </span>
          <span className="text-[10px] text-[#484848]">
            {carrier.carrier_id}
          </span>
        </section>
        <section className="grid w-[164px] grid-cols-[auto_auto] justify-around gap-[16px] rounded-[5px] bg-[#D6D6D6] px-[16px] py-[6px]">
          <section className="grid gap-[4px]">
            <span className="text-[10px] font-[500] text-[#484848]">
              {!carrier.mc_number ? "- -" : carrier.mc_number}
            </span>
            <span className="text-[8px] text-[#919191]">MC</span>
          </section>
          <section className="grid gap-[4px]">
            <span className="text-[10px] font-[500] text-[#484848]">
              {!carrier.dot_number ? "- -" : carrier.dot_number}
            </span>
            <span className="text-[8px] text-[#919191]">DOT</span>
          </section>
        </section>
      </section>
    </section>
  );
};
